import { Autocomplete, Paper } from "@mui/material";
import styled from "styled-components";

interface IStyledSelectBoxProps  {
   error: boolean; 
   boldLabel: boolean;
}

const StyledSelectbox = styled(Autocomplete)<IStyledSelectBoxProps>`
${({theme, error, boldLabel}) => `
@media (max-width: 1024px) {
  margin-right:0 !important;
}
Checkbox{
  margin-right: ${theme.uptimeSpace[4]}px;
  CheckBoxOutlineBlankIcon, CheckBoxIcon{
    font-size: small;
  }
}
&.MuiAutocomplete-root{

  .MuiFormLabel-root {
    font-family:  ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    position: relative;
    color: ${theme.uptimeColors.textColors.primary};
    font-weight: ${boldLabel ? 'bold' : 'normal'};
    font-size: ${boldLabel ? `${theme.uptimeFontSizes.desktop.fz4}px` : 'unset'};
    margin-bottom: ${theme.uptimeSpace[4]}px;

    &.MuiInputLabel-animated {
      transition: unset;
    }

    &.MuiInputLabel-formControl {
      transform: unset;
    }
    &#DeviceType-label {
      max-width: unset;
    }

    .MuiFormLabel-asterisk {
      color: ${theme.uptimeColors.generalColors.state.danger.light};
      margin-left: ${theme.uptimeSpace[3]}px;
      font-weight: ${boldLabel ? 'bold' : 'normal'};
    }
  }

  .MuiInputBase-root {
    height: ${theme.uptimeSpace[20]}px;
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    padding: 0;
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    .MuiInputBase-input {
      margin-top: -${theme.uptimeSpace[1]}px;
      padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[12]}px !important;
    }
    .MuiAutocomplete-endAdornment {
      .MuiIconButton-root {
        padding: ${theme.uptimeSpace[0]};
        border-radius: 0;
        color: none;      
      }
    }   
    fieldset{
      top: 0;
    }
  }
  .MuiAutocomplete-paper{
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
  }

  &.Mui-focused fieldset {
    border-color: ${theme.uptimeColors.mainTheme.secondary};
  }

  fieldset,
  .MuiOutlinedInput-notchedOutline {
    border-color: ${error ? theme.uptimeColors.generalColors.state.danger.light : theme.uptimeColors.grayScales.gray}
  }

  legend {
    display: none;
  }
}
`}`

const StyledSelectErrorMessage  = styled('div')`
  ${({theme}) => `
    display: flex;
    align-items: center;
    color: ${theme.uptimeColors.generalColors.state.danger.light};
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
    margin: ${theme.uptimeSpace[0]};
    padding-top: ${theme.uptimeSpace[3]}px;
    .warning-icon {
      margin-right: ${theme.uptimeSpace[2]}px;
      font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
    }
  `}
`

const StyledTagName  = styled('p')`
  ${({theme}) => `
    margin-left: ${theme.uptimeSpace[5]}px;
    color: ${theme.uptimeColors.grayScales.darkGray};
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
  `}
` 

const StyledPaper = styled(Paper)(({ theme }) => `
  .MuiAutocomplete-option {
    padding-left: ${theme.uptimeSpace[12]}px;
    height: 40px !important;
  }
  .MuiAutocomplete-loading {
    padding-left: ${theme.uptimeSpace[12]}px;
    color: ${theme.uptimeColors.mainTheme.secondary};
  }
`);

export {
  StyledSelectbox,
  StyledSelectErrorMessage,
  StyledPaper,
  StyledTagName
}
